import { render, staticRenderFns } from "./price-desc.vue?vue&type=template&id=eaa6131a&scoped=true&"
import script from "./price-desc.vue?vue&type=script&lang=js&"
export * from "./price-desc.vue?vue&type=script&lang=js&"
import style0 from "./price-desc.vue?vue&type=style&index=0&id=eaa6131a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa6131a",
  null
  
)

export default component.exports